import React, { useEffect, useState } from "react";
import { VertButton, VertTypography } from "@vertem-core/vertice-ds";
import { CalendarOutlined, SmileOutlined, InfoCircleOutlined, GiftOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import 'Assets/styles/default/components/PopBallon/CustomCard.less';
import { format } from 'date-fns';
import { useDispatch, useSelector } from "react-redux";
import { postResgate } from 'redux/Reducers/PopBallon/VertemGiftApi';
import { useNavigate } from 'react-router-dom';
import { ModalCompleteRedemption } from "./ModalCompleteRedemption";
import { usePlaceholderLoading } from "../../PlaceholderLoading";



const CustomCard = ({ props }) => {
    const dispatch = useDispatch();
    const Navigate = useNavigate();

    const awarded = (props?.status === 2 || props?.status === 3) ? true : false;
    const rescued = (props?.status === 3) ? true : false;
    const formattedDate = format(new Date(props.createdAt), 'dd/MM/yyyy, HH:mm');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { setLoading } = usePlaceholderLoading()
    const goToDetailsHandler = (orderId) => {
        if (orderId) {
            Navigate(`/order-details?orderId=${orderId}&fromCheckout=${false}`);
        }
    };
    const getPrize = async (balloonId) => {
        setIsModalVisible(false)
        await dispatch(postResgate(balloonId))
        setLoading(false)
        Navigate('/my-orders')
    }

    return (
        <div className={`card-wrapper ${awarded ? "awarded" : "not-awarded"}`}>
            <div className="card-content">
                <div className="product-info-ballon">
                    {awarded ?
                        <>
                            <img src={props.skuImage} alt="Thumbnail" />
                            <div className="product-text-info">
                                <VertTypography.Paragraph>
                                    <CalendarOutlined className="awarded-icons" /> {formattedDate}
                                </VertTypography.Paragraph>
                                <VertTypography.Paragraph>
                                    <GiftOutlined className="awarded-icons" /> {props.skuName}
                                </VertTypography.Paragraph>
                            </div>
                        </> :
                        <>
                            <div className="product-text-info">
                                <VertTypography.Paragraph>
                                    <CalendarOutlined className="unawarded-icons" />{formattedDate}
                                </VertTypography.Paragraph>
                                <VertTypography.Paragraph>
                                    <SmileOutlined className="unawarded-icons" />
                                    Balão não premiado!
                                </VertTypography.Paragraph>
                            </div>
                        </>
                    }
                </div>
                {isModalVisible &&
                    <ModalCompleteRedemption
                        isOpen={isModalVisible}
                        onCancel={() => setIsModalVisible(false)}
                        getPrizeCallback={() => getPrize(props.balloonRedemptionId)}
                    />}
                {awarded ? <>
                    <div className="product-info-ballon order-details">
                        {rescued ?
                            <VertButton
                                className="button-details"
                                type="highlight"
                                onClick={() => goToDetailsHandler(props.parentOrderId)}
                            >
                                Exibir detalhes
                            </VertButton> :
                            <VertButton
                                className="button-details"
                                type="highlight"
                                onClick={() => setIsModalVisible(true)}
                            >
                                Resgate seu Prêmio
                            </VertButton>
                        }

                    </div>
                </> :
                    <>
                        <VertTypography.Paragraph
                            // @ts-ignore
                            style={{ color: '#1890ff', fontSize: '12px' }}>
                            Todos os dias dos mês de Maio você tem a chance de ganhar um prêmio. Siga resgatando* seus pontos e boa sorte!
                            <VertTypography.Paragraph
                                // @ts-ignore
                                style={{ color: '#1890ff', fontSize: '10px', marginTop: '4%' }}>
                                *Limitado a um resgate por dia.
                            </VertTypography.Paragraph>
                        </VertTypography.Paragraph>

                    </>}
            </div>
        </div>

    );
}

export default CustomCard;
